import type { Module } from 'vuex'
import { clone } from 'ramda'

import type { CashRegisterState, RootState } from '@/types/store'
// import moment from 'moment'
// import { ENDPOINTS } from '@/lib/consts.ts'

// const EXPIRATION_REGISTER_MS = 30 * 1000

const DEFAULT_STATE = {
  selectedRegister: null,
  // lastUpdateTimestamp: null
}

const cashRegisterModule: Module<CashRegisterState, RootState> = {
  namespaced: true,

  /*!
   *
   * state
   *
   */
  state: {
    ...clone(DEFAULT_STATE),
  },

  /*!
   *
   * actions
   *
   */
  actions: {

    /*
     *
     * refresh selected cash register
     * @public
     *
     */
    // refreshRegister ({ state, dispatch, commit, rootState }) {
    //   return new Promise(async (resolve, reject) => {
    //     if (
    //       state.lastUpdateTimestamp &&
    //       (moment().format('x') - state.lastUpdateTimestamp) < EXPIRATION_REGISTER_MS
    //     ) {
    //       resolve(state.selectedRegister)
    //     } else if (!state.selectedRegister) {
    //       resolve()
    //     } else {
    //       const businessId = rootState.business.business.id

    //       dispatch('api/call', {
    //         method: 'GET',
    //         url: ENDPOINTS.POS_REGISTERS_ID,
    //         urlParams: {
    //           businessId,
    //           registerId: state.selectedRegister.id
    //         }
    //       }, {
    //         root: true
    //       }).then(({ data: { register } }) => {
    //         // check this register is still open and update new state
    //         commit('setRegister', register.is_open ? register : null)
    //         resolve(register)
    //       }).catch(e => {
    //         return reject(e)
    //       })
    //     }
    //   })
    // }
  },

  /*!
   *
   * mutations
   *
   */
  mutations: {
    setRegister (state, register) {
      // state.lastUpdateTimestamp = moment().format('x')
      state.selectedRegister = register
    },

    // setLastUpdateTimestamp (state, timestamp) {
    //   state.lastUpdateTimestamp = timestamp
    // }
  },

  /*!
   *
   * getters
   *
   */
  getters: {
  },
}

export default cashRegisterModule
